var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof h7_module !== "undefined") return resolve();
	__webpack_require__.l("https://app-h7-bff-als-prd.azurewebsites.net/remoteEntry.js", (event) => {
		if(typeof h7_module !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "h7_module");
}).then(() => (h7_module));